import { IGetAllVerbaPagamentoUseCase } from "../../../presentation/useCases/read/get_all_verba_pagamento_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { VerbaPagamento } from "../../models/verba_pagamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllVerbaPagamentoUseCase
 */

export class GetAllVerbaPagamentoUseCase extends BasePaginatedUseCase<VerbaPagamento> implements IGetAllVerbaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllVerbaPagamento(
    tipoPesquisa: number | null,
    valueField: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllVerbaPagamento(
      tipoPesquisa ?? 1,
      valueField ?? "",
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
